module.exports = __webpack_public_path__ + "static/media/loader.8e7a72f3.gif";